import React from 'react';
import './style.scss';

interface ICheckBox {
    value: boolean,
    onChange: (value: boolean) => any,
    extraClass?: string,
}

const CheckBox: React.FC<ICheckBox> = ({value, onChange, extraClass}) => {
    const handleChange = () => {
        onChange(!value)
    }
    return (
        <span className={`check-box-item ${value ? 'beChosen' : ''} ${extraClass ? extraClass : ''}`} onClick={() => handleChange()}></span>
    )
}

export default CheckBox;
